import React, { useEffect, useRef } from 'react';
import './UpdateCredentialsModal.css';
import { groupActivityByDay, ACTIVITY_KEEP_MS } from '../utils/activityLog';

// Profile → Activity: the last three days of what happened to you in Udal, newest first, by day —
// the web's counterpart of the phone's ActivityScreen. 2026-10-28: this was a panel along the bottom
// of the map, kept only for as long as the tab was open.
//
// Uses the same dialog frame as Change email / Change password.
const KEEP_DAYS = Math.round(ACTIVITY_KEEP_MS / (24 * 60 * 60 * 1000));
const TINT = { green: '#2e7d32', red: '#c62828', blue: '#1565c0', purple: '#512da8' };
const timeOf = (ms) => new Date(ms).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

const ActivityModal = ({ entries, seenAt, onSeen, onClose }) => {
  // New when the dialog opened stays marked while it is open; the dot itself clears at once.
  const newSince = useRef(seenAt);
  useEffect(() => { onSeen?.(); }, [onSeen]);
  const sections = groupActivityByDay(entries || []);

  return (
    <div className="update-credentials-modal-overlay" onClick={onClose}>
      <div className="update-credentials-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <div className="update-credentials-modal-header">
          <h2>Activity</h2>
          <button className="update-credentials-modal-close-button" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="update-credentials-modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {sections.length === 0 ? (
            <p style={{ textAlign: 'center', color: 'var(--ink-faint, #8b86a0)', margin: '24px 0' }}>
              Nothing in the last {KEEP_DAYS} days. Spots, requests and handovers show up here.
            </p>
          ) : sections.map((section) => (
            <section key={section.title} style={{ marginBottom: 16 }}>
              <h3 style={{ fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.04em', color: 'var(--ink-faint, #8b86a0)', margin: '0 0 6px' }}>
                {section.title}
              </h3>
              <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {section.data.map((e, i) => {
                  const isNew = newSince.current != null && e.rawTime > newSince.current;
                  return (
                    <li key={`${e.rawTime}-${i}`} style={{ display: 'flex', gap: 12, padding: '8px 0', borderTop: i ? '1px solid var(--line, #e3e3e8)' : 'none' }}>
                      <span style={{ minWidth: 68, whiteSpace: 'nowrap', flexShrink: 0, color: 'var(--ink-faint, #8b86a0)', fontVariantNumeric: 'tabular-nums' }}>{timeOf(e.at)}</span>
                      <span style={{ flex: 1, color: TINT[e.color] || 'var(--ink, #222)', fontWeight: isNew ? 600 : 400 }}>{e.msg}</span>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
          <p style={{ fontSize: '0.8rem', color: 'var(--ink-faint, #8b86a0)', textAlign: 'center', margin: '8px 0 0' }}>
            Kept in this browser for {KEEP_DAYS} days, and cleared when you log out.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivityModal;
